import styles from './calendar.module.scss'
import lineImage from 'assets/images/line2.png'

const Calendar = () => {
  return (
    <section className={styles.section}>
      <img src={lineImage} alt='' className={styles.decorativeLine} />
      <h2>예식일시</h2>
      <p className={styles.date}>2026. 01. 24. (토) 15시</p>
      <div className={styles.calendar}>
        <div className={styles.month}>1월</div>
        <table>
          <tbody>
            <tr className={styles.dayOfWeek}>
              <th>일</th>
              <th>월</th>
              <th>화</th>
              <th>수</th>
              <th>목</th>
              <th>금</th>
              <th>토</th>
            </tr>
            <tr>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>
                <span>1</span>
              </td>
              <td>
                <span>2</span>
              </td>
              <td>
                <span>3</span>
              </td>
            </tr>
            <tr>
              <td>
                <span>4</span>
              </td>
              <td>
                <span>5</span>
              </td>
              <td>
                <span>6</span>
              </td>
              <td>
                <span>7</span>
              </td>
              <td>
                <span>8</span>
              </td>
              <td>
                <span>9</span>
              </td>
              <td>
                <span>10</span>
              </td>
            </tr>
            <tr>
              <td>
                <span>11</span>
              </td>
              <td>
                <span>12</span>
              </td>
              <td>
                <span>13</span>
              </td>
              <td>
                <span>14</span>
              </td>
              <td>
                <span>15</span>
              </td>
              <td>
                <span>16</span>
              </td>
              <td>
                <span>17</span>
              </td>
            </tr>
            <tr>
              <td>
                <span>18</span>
              </td>
              <td>
                <span>19</span>
              </td>
              <td>
                <span>20</span>
              </td>
              <td>
                <span>21</span>
              </td>
              <td>
                <span>22</span>
              </td>
              <td>
                <span>23</span>
              </td>
              <td className={styles.dday}>
                <span>24</span>
              </td>
            </tr>
            <tr>
              <td>
                <span>25</span>
              </td>
              <td>
                <span>26</span>
              </td>
              <td>
                <span>27</span>
              </td>
              <td>
                <span>28</span>
              </td>
              <td>
                <span>29</span>
              </td>
              <td>
                <span>30</span>
              </td>
              <td>
                <span>31</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  )
}

export default Calendar
